import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLResponsysService {
    static sendDataToResponsys(jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policycommonanalytics'),
            'sendData',
            [jobNumber],
            additionalHeaders
        );
    }
}
